import { Button } from "@egaranti/components";
import { Label } from "@egaranti/components";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@egaranti/components";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@egaranti/components";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import useCampaignsStore from "@/stores/useCampaignsStore";

const ApplicationsFilterSheet = ({ onOpenChange, open }) => {
  const { t } = useTranslation();
  const {
    applicationFilters: filters,
    validCampaigns,
    getApplications,
    setApplicationFilters: setFilters,
  } = useCampaignsStore();

  const [localFilters, setLocalFilters] = useState({
    status: "ALL",
    campaignId: "",
  });

  const statusOptions = [
    { value: "ALL", label: t("applicationsPage.tabs.all", "Tümü") },
    {
      value: "PENDING",
      label: t("applicationsPage.tabs.pending", "Bekleyen"),
    },
    {
      value: "APPROVED",
      label: t("applicationsPage.tabs.approved", "Onaylanan"),
    },
    {
      value: "REJECTED",
      label: t("applicationsPage.tabs.rejected", "Reddedilen"),
    },
    {
      value: "PROCESSED",
      label: t("applicationsPage.tabs.processed", "İşlenen"),
    },
  ];

  useEffect(() => {
    setLocalFilters({
      status: filters.status || "ALL",
      campaignId: filters.campaignId || "",
    });
  }, [filters]);

  const onSaveFilter = () => {
    onOpenChange(false);
    const campaignId =
      localFilters.campaignId === "ALL" ? "" : localFilters.campaignId;
    setFilters({
      ...filters,
      status: localFilters.status,
      campaignId,
    });
    getApplications();
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="m-4 rounded-lg bg-white p-4">
        <SheetHeader>
          <SheetTitle>{t("common.addFilter", "Filtre Ekle")}</SheetTitle>
        </SheetHeader>
        <div className="mt-4 flex flex-col gap-4">
          <div>
            <Label>{t("applicationsPage.status", "Durum")}</Label>
            <Select
              value={localFilters.status}
              onValueChange={(value) =>
                setLocalFilters({ ...localFilters, status: value })
              }
            >
              <SelectTrigger className="mt-1">
                <SelectValue
                  placeholder={t(
                    "applicationsPage.selectStatus",
                    "Durum Seçin",
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>{t("applicationsPage.campaign", "Kampanya")}</Label>
            <Select
              value={localFilters.campaignId || "ALL"}
              onValueChange={(value) =>
                setLocalFilters({ ...localFilters, campaignId: value })
              }
            >
              <SelectTrigger className="mt-1">
                <SelectValue
                  placeholder={t(
                    "applicationsPage.selectCampaign",
                    "Kampanya Seçin",
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="ALL">
                  {t("applicationsPage.tabs.all", "Tümü")}
                </SelectItem>
                {validCampaigns.map((campaign) => (
                  <SelectItem key={campaign.id} value={String(campaign.id)}>
                    {campaign.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <SheetFooter className="mt-4">
          <Button onClick={onSaveFilter}>{t("common.save", "Kaydet")}</Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default ApplicationsFilterSheet;
